import { defineComponent as _defineComponent } from 'vue'
import ClickMenu from '@/components/menu/ClickMenu.vue';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import { translateFilterTimeSpanEnum } from '@/utils/i18n';
import { values } from '@/utils/enum';
import { computed } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TimeSpanFilter',
  props: {
    value: { default: FilterTimeSpanEnum.Day },
    size: { default: '' }
  },
  setup(__props: any) {



const ids = computed((): FilterTimeSpanEnum[] =>
  values(FilterTimeSpanEnum).filter(
    (value) => value !== FilterTimeSpanEnum.None,
  ),
);

const names = computed((): string[] =>
  ids.value.map((x: FilterTimeSpanEnum) => translateFilterTimeSpanEnum(x)),
);

return { __sfc: true,ids, names, ClickMenu, translateFilterTimeSpanEnum }
}

})